import { useState, useEffect } from 'react';
import throttle from 'lodash.throttle';

// Viewport width used for the server render, and therefore for the client's
// FIRST render too — if the two disagree, hydration mismatches (React #418).
//
// 360 is a phone-sized width, chosen to stay consistent with SSR_BREAKPOINT
// ('xs') in useBreakpoint.js so server markup is internally coherent. The real
// width is resolved after mount.
export const SSR_DEVICE_WIDTH = 360;

// Reads window.innerWidth without breaking hydration. Components must never
// read window.innerWidth directly in a render body: the server evaluates
// `typeof window !== 'undefined' && window.innerWidth` to `false`, so the
// server and the client's first render disagree.
const useDeviceWidth = () => {
  const [deviceWidth, setDeviceWidth] = useState(SSR_DEVICE_WIDTH);

  useEffect(() => {
    setDeviceWidth(window.innerWidth);

    const calcInnerWidth = throttle(() => {
      setDeviceWidth(window.innerWidth);
    }, 200);

    window.addEventListener('resize', calcInnerWidth);
    return () => {
      calcInnerWidth.cancel?.();
      window.removeEventListener('resize', calcInnerWidth);
    };
  }, []);

  return deviceWidth;
};
export default useDeviceWidth;
